import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-caijiyeshu",
  "use": "icon-caijiyeshu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-caijiyeshu\"><path d=\"M928.237037 453.214815V305.303704L617.244444 0H201.323457C143.17037 0 95.762963 47.407407 95.762963 99.871605v821.728395c0 58.153086 47.407407 99.871605 105.560494 99.871605h616.296296c58.153086 0 110.617284-47.407407 110.617284-110.617284V453.214815z m-363.45679-379.259259l284.444444 284.444444h-284.444444v-284.444444z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol